<template>
  <div id="app">
    <b-container>
      <b-row>
        <b-col :key="key" v-for="(log, key) in ticket_logs" col lg="4">
          <b-card tag="article" class="mb-3" :title="log.reference_code">
            <b-card-text>{{log.email}}</b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { db } from "../firebase";

export default {
  name: "app",
  data() {
    return {
      ticket_logs: []
    };
  },
  firebase: {
    ticket_logs: db.ref("ticket_logs")
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 60px;
}
</style>
